<template>
  <div class="box" v-if="on_off">
    <div class="ct">
      <!--    <img  src="../../static/images/float-ewm-x.png" alt /> -->
      <!--  <img v-else src="../../static/images/float-ewm.png" alt />-->

      <!--    <img
        v-if="this.$route.path == '/penguin'"
        class="close"
        @click="ban_ewm"
        src="../../static/images/ban_ewm-x.png"
        alt
      />
      <img
        v-else
        class="close"
        @click="ban_ewm"
        src="../../static/images/ban_ewm.png"
        alt
      /> -->
    </div>
  </div>
</template>

<script>
export default {
  mounted() {},
  data() {
    return {
      on_off: true
    };
  },
  methods: {
    ban_ewm() {
      this.on_off = false;
    }
  }
};
</script>
<style lang="less" scoped>
.box {
  .ct {
    width: 145px;
    height: 231px;
    position: relative;
    .close {
      cursor: pointer;
      position: absolute;
      top: -13px;
      left: 129px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/floatewm.vue